// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"4a3bdef7","879":"96e3f789"}[chunkId] + ".chunk.js";
};